import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '../../../create-mock-endpoint';

export const walletUserBalanceAdjust = http.patch(
  createMockEndpoint('/wallet_user/:walletUserId/balance'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
